import React, { useEffect, useState } from "react";
import { getContentById } from "../../API/content";
import "./SalaahTimes.css";

export default function SalaahTimes() {
  const [salaahData, setSalaahData] = useState(null);
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const data = await getContentById("salaahTimes");
    setSalaahData(data);
  };

  return (
    <div className="SalaahTimes">
      <div className="salaahTimesHead">
        <h1>Salaah Times 2022</h1>
      </div>
      <div className="salaah-items">
        <div className="salaahContainer">
          {salaahData?.map((data) => (
            <div className="salaahData" key={data.id}>
              <a
                href={data.link.fields.file.url}
                target="_blank"
                rel="noreferrer"
              >
                <img src="assets/Rectangle 18.png" alt="" />
                <br />
                <p>{data.subTitle}</p>
              </a>
            </div>
          ))}
        </div>
        <div className="button-pdf-salaah">
          <button>
            <a style={{ color: "white" }} href="#calendarModal">
              View calendar
            </a>
          </button>
        </div>
      </div>
      <div className="LiveStreams">
        <div className="liveRight"></div>
        <div className="liveLeft">
          <hr />
          <h1>LIVESTREAMS</h1>
          <hr />
          <p>
            Watch our official livestreams on{" "}
            <a
              style={{ textDecoration: "underline", color: "red" }}
              href="https://www.youtube.com/c/CMRMmedia"
            >
              YouTube
            </a>
          </p>
          <br />
          <p>Subscribe to our Youtube Channel</p>
          <div className="button-foot">
            <button>
              <a
                style={{ textDecoration: "none", color: "white" }}
                href="https://www.youtube.com/c/CMRMmedia"
              >
                Subscribe
              </a>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
